import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { api, imgUrl } from "@/lib/api";
import { BookingDialog } from "@/components/BookingDialog";
import { ListingDetail } from "@/components/ListingDetail";

const FALLBACK_GALLERY = [imgUrl("/api/files/bookedbybenj/site/model.png")];

export default function ModelsPage() {
  const [listings, setListings] = useState(null);
  const [gallery, setGallery] = useState(FALLBACK_GALLERY);
  const [sub, setSub] = useState("Agency vetted talent available for music videos, film, television, events, photoshoots and brand campaigns.");
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    api.get("/listings", { params: { type: "model" } }).then((r) => setListings(r.data)).catch(() => setListings([]));
    api.get("/site/content").then((r) => {
      if (r.data?.models_gallery?.length) setGallery(r.data.models_gallery.map(imgUrl));
      if (r.data?.site_text?.models_sub) setSub(r.data.site_text.models_sub);
    }).catch(() => {});
  }, []);

  return (
    <div data-testid="models-page">
      <div className="max-w-7xl mx-auto px-6 pt-20 pb-8">
        <p className="text-xs tracking-[0.4em] uppercase text-brand mb-4">Talent</p>
        <div className="flex flex-wrap items-end justify-between gap-6 mb-4">
          <h1 className="font-display text-6xl sm:text-7xl text-white">Models</h1>
          <BookingDialog type="model" testId="book-general-model-btn" triggerLabel="Request Models" />
        </div>
        <p className="text-sm md:text-base text-zinc-400 max-w-3xl leading-relaxed">{sub}</p>
      </div>

      {/* Rotating gallery */}
      <div data-testid="models-carousel" className="py-8 border-y border-white/10 bg-[#0A0A0A] overflow-hidden">
        <Marquee speed={35} gradient={false} pauseOnHover>
          {gallery.map((img, i) => (
            <img key={i} src={img} alt="Model" className="h-72 w-auto object-cover mx-3 border border-white/10" />
          ))}
        </Marquee>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-16">
        {listings === null ? (
          <p className="text-zinc-500">Loading…</p>
        ) : listings.length === 0 ? (
          <div className="border border-white/10 p-12 text-center">
            <p className="text-zinc-400">New talent is being added. Request above and we'll source for you.</p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {listings.map((l) => (
              <button key={l.id} data-testid={`listing-card-${l.id}`} onClick={() => setDetail(l)}
                className="group text-left border border-white/10 hover:border-brand/60 transition-colors duration-300 overflow-hidden hover:-translate-y-1">
                <div className="aspect-[4/3] overflow-hidden">
                  <img src={imgUrl(l.images?.[0])} alt={l.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-6">
                  <h2 className="font-display text-2xl text-white">{l.title}</h2>
                  <p className="text-sm text-zinc-400 mt-2 leading-relaxed line-clamp-2">{l.description}</p>
                  <span className="inline-block text-xs tracking-widest uppercase text-brand mt-4">View & Book</span>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
      <ListingDetail listing={detail} type="model" open={!!detail} onClose={() => setDetail(null)} />
    </div>
  );
}
